import { useEffect, useRef, useState } from 'react';
import { LogContainer, LogContent, LogHeader, LogTBody, LogTHead, LogTable, } from './Log.styled';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { useI18n } from '@i18n/useI18n';
import moment from 'moment';
import { useStore } from '@store/appStore';

interface IProps {
  list:any,
  rewardId:number,
  rewardTitle:string,
}

const Log = (props: IProps) => {
  const { callNameSetting } = useStore();
  const i18n = useI18n();
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(null)
  const ref = useRef(null)

  let idList = props.list?.filter(f => f.reward_id === props.rewardId);

  useEffect(() => {
        setHeight(ref.current?.scrollHeight) 
  }, [])

  return (
          <LogContainer>
            <LogHeader onClick={() => setOpen(!open)}>
              <h3>{props.rewardTitle} ({idList?.length})</h3>
              <span>{open?"-":"+"}</span>
            </LogHeader>
            <LogContent ref={ref} open={open} elementHeight={height}>
              <LogTable>
                <LogTHead>
                  <tr>
                    <th>{i18n.t('date')}</th>
                    <th>{i18n.t('reward-cost')}</th>
                    <th>{i18n.t(callNameSetting)}</th>
                    <th>{i18n.t('redeemed-by')}</th>
                  </tr>
                </LogTHead>
                <LogTBody>
                  {idList?.map((l, index) => (
                    <tr key={index + "_LogItem"}>
                      <td>{moment(l.timestamp).format('HH:mm - DD-MM-YY')}</td>
                      <td>{l.amount} </td>
                      <td>{l.customer} </td>
                      <td>{l.clerk} </td>
                    </tr>
                  ))}
                </LogTBody>
              </LogTable>
            </LogContent>
          </LogContainer>
  );
};

export default Log;
